import { Component } from '@theme/component';
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
import { DrawerOpenEvent, DrawerCloseEvent } from '@theme/theme-drawer';

class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  #accountPressController = null;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    document.addEventListener(DrawerOpenEvent.eventName, this.#onDrawerStateChange);
    document.addEventListener(DrawerCloseEvent.eventName, this.#onDrawerStateChange);
    this.addEventListener('pointerdown', this.#onAccountPointerDown);
    this.#syncCartTriggerAriaExpanded();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    document.removeEventListener(DrawerOpenEvent.eventName, this.#onDrawerStateChange);
    document.removeEventListener(DrawerCloseEvent.eventName, this.#onDrawerStateChange);
    this.removeEventListener('pointerdown', this.#onAccountPointerDown);
    this.#accountPressController?.abort();
    this.querySelector('.account-button[data-cg-account-pressing]')?.removeAttribute('data-cg-account-pressing');
  }

  #syncCartTriggerAriaExpanded = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;
    const trigger = this.querySelector('[aria-controls="cart-drawer"]');
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', cartDrawer.hasAttribute('open') ? 'true' : 'false');
  };

  #onDrawerStateChange = (event) => {
    const target =   (event.target);
    if (target?.id !== 'cart-drawer') return;
    this.#syncCartTriggerAriaExpanded();
  };

  #onAccountPointerDown = (event) => {
    const pressTarget =   (
      event.composedPath().find((node) => node instanceof Element && node.matches('[data-cg-account-press-target]'))
    );
    if (!pressTarget || !this.contains(pressTarget)) return;

    const accountButton = pressTarget.closest('.account-button');
    if (!(accountButton instanceof HTMLElement)) return;

    this.#accountPressController?.abort();
    const controller = new AbortController();
    this.#accountPressController = controller;
    accountButton.setAttribute('data-cg-account-pressing', '');

    const release = () => {
      accountButton.removeAttribute('data-cg-account-pressing');
      if (this.#accountPressController === controller) this.#accountPressController = null;
      controller.abort();
    };

    document.addEventListener('pointerup', release, { once: true, signal: controller.signal });
    document.addEventListener('pointercancel', release, { once: true, signal: controller.signal });
    accountButton.addEventListener('pointerleave', release, { once: true, signal: controller.signal });
  };

  #onCartUpdate = (event) => {
    event.promise
      ?.then(({ cart }) => {
        const cartCount = cart?.totalQuantity;
        if (cartCount === undefined) return;

        this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[header-actions] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
